import { Schemas } from "schemas/schemas";

export const getQuery = (brandId: string) => {
    return {
        brandId,
        force: true,
        options: {
            method: "GET",
        },
        schema: Schemas,
        url: `/brand/${brandId}/schemas`,
    };
};
